<template>
<div id="Toast">
  <div class="mask" v-show="toastShow">

  </div>
  <transition name="fade">
    <div class="content" v-show="toastShow" :class="{'top':position=='top'}">
      <div class="inner">
        <img src="../../assets/icon/image_error@3x.png" alt="">
        <p>{{text}}</p>
      </div>
    </div>
  </transition>
</div>
</template>



<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    toastShow: {
      type: Boolean,
      default: false
    }
  },
  created() {

  },
  data() {
    return {}
  },
  methods: {

  },
  computed:{
    position(){
      return this.$store.state.toastPosition
    }
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
#Toast {
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.1);
        z-index: 1000;
    }
    .content {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 1001;
        width: 130px;
        height: 136px;
        border-radius: 8px;
        background: rgba(0,0,0,0.6);
        &.top{
          top: 18%;
        }
        .inner {
            img {
                display: block;
                width: 50px;
                height: auto;
                margin: 12px auto 0;
            }
            p {
                color: #FFF;
                text-align: center;
                box-sizing: border-box;
                padding: 12px;
                line-height: 18px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                height: 67px;
                font-size: 13px;
            }
        }
    }

}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}</style>



// WEBPACK FOOTER //
// Toast.vue?9b4feac2